import React from 'react'
import PropTypes from 'prop-types'
import Lib from '../../loader'
import propType from '../SurfacePropTypes'

function AppBar({
  children,
  className,
  position,
  fontSize,
}) {
  return (
    <Lib.AppBar
      fontSize={fontSize}
      className={className}
      position={position}
    >
      { children }
    </Lib.AppBar>
  )
}

AppBar.defaultProps = {
  position: 'fixed',
  fontSize: 'h6',
}

AppBar.propTypes = {
  ...propType,
  fontSize: PropTypes.oneOf([
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
  ]),
  position: PropTypes.oneOf([
    'absolute',
    'fixed',
    'relative',
    'static',
    'sticky',
  ]),
}

export default AppBar
